import * as routes from '@/pages/routes.ts'
import {
    AppstoreOutlined,
    BarChartOutlined,
    DollarOutlined,
    EyeOutlined,
    FilterOutlined,
    FunnelPlotOutlined,
    IdcardOutlined,
    PictureOutlined,
    RetweetOutlined,
    SaveOutlined,
    UnorderedListOutlined
} from '@ant-design/icons'
import {AgencyBean} from 'common/api/api.ts'
import {MenuItem} from 'common/components/sidebar/Sidebar.tsx'
import {CommonRoutes} from 'common/context/commonRoutes.ts'
import FeatureAccessEnum = AgencyBean.FeatureAccessEnum

export const menuTabs: MenuItem[] = [
    {
        label: 'Dashboard',
        key: CommonRoutes.DASHBOARD,
        url: CommonRoutes.DASHBOARD,
        icon: <AppstoreOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Report Builder',
        key: CommonRoutes.REPORT_BUILDER,
        url: CommonRoutes.REPORT_BUILDER,
        icon: <BarChartOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Saved Reports',
        key: CommonRoutes.REPORT,
        url: CommonRoutes.REPORT,
        icon: <SaveOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Campaigns',
        key: CommonRoutes.CAMPAIGN,
        url: CommonRoutes.CAMPAIGN,
        icon: <UnorderedListOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Ad Groups',
        key: CommonRoutes.AD_GROUP,
        url: CommonRoutes.AD_GROUP,
        icon: <IdcardOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Creatives',
        key: CommonRoutes.CREATIVE,
        url: CommonRoutes.CREATIVE,
        icon: <PictureOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Trackers',
        key: CommonRoutes.TRACKER,
        url: CommonRoutes.TRACKER,
        icon: <EyeOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    // {
    //     label: 'Tracker Statistics',
    //     key: 'tracker-event-stats',
    //     url: 'tracker-event-stats',
    //     access: [FeatureAccessEnum.Advertiser],
    //     icon: <DatabaseOutlined/>,
    // },
    {
        label: 'Tracker Reports',
        key: CommonRoutes.TRACKER_EVENT_REPORT,
        url: CommonRoutes.TRACKER_EVENT_REPORT,
        access: [FeatureAccessEnum.Advertiser],
        icon: <SaveOutlined/>,
    },
    {
        label: 'Retargeting Lists',
        key: CommonRoutes.RETARGETING_LIST,
        url: CommonRoutes.RETARGETING_LIST,
        icon: <RetweetOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    // {
    //     label: 'Contextual',
    //     key: 'contextual-targeting',
    //     url: 'contextual-targeting',
    //     icon: <AimOutlined/>,
    //     access: [FeatureAccessEnum.Advertiser],
    // },
    {
        label: 'Filter Lists',
        key: CommonRoutes.FILTER_LIST,
        url: CommonRoutes.FILTER_LIST,
        icon: <FilterOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Global Filters',
        key: CommonRoutes.FILTER_LIST_GLOBAL,
        url: CommonRoutes.FILTER_LIST_GLOBAL,
        icon: <FunnelPlotOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
    {
        label: 'Billing',
        key: routes.BILLING_HISTORY,
        url: routes.BILLING_HISTORY,
        icon: <DollarOutlined/>,
        access: [FeatureAccessEnum.Advertiser],
    },
]
